














helpers = require('../../../helpers.coffee')
summernote = require('../../../libraries/summernote_comments.coffee')

view_model = {
  data: ->
    contact: new Contact
    show_comment_modal: false
    edit_comment: false
    comment_event: new ContactEvent
    task: null
    template: null
    variables: null

  methods:
    new: (data) ->
      contact = data.contact
      template = data.template
      @show_comment_modal = !@show_comment_modal
      if @show_comment_modal
        @edit_comment = false
        @contact = contact
        if template
          @template = template
          @setSummernoteCode()
        else 
          @$comment.summernote('code', '')
        @comment_event = new ContactEvent

    edit: (data) ->
      @show_comment_modal = true
      @edit_comment = true
      @contact = data.contact
      @comment_event = data.comment
      @$comment.summernote('code', @comment_event.comment)

    reloadContact: (contact) ->
      @contact = contact
      if @template
        @setSummernoteCode()
      else 
        @$comment.summernote('code', '')

    close: ->
      @show_comment_modal = false
      @$comment.summernote('code', '')
      @template = null

    confirmRemoveComment:->
      params = { id: @comment_event.id }
      @comment_events_resource.destroy @destroySuccess, @unknownError, params
      @close()

    destroySuccess: ->
      alertify.success 'Comentário excluído com sucesso!'
      EventsBus.$emit 'Comment::Destroyed', @comment_event

    inializeSummernote: ->
      @$comment = jQuery('#comment-modal')
      summernote(@$comment, focus: false)
      @$comment.summernote('code','')

    saveComment: ->
      comment_text = @$comment.summernote('code')
      if comment_text.length == 0 || comment_text == '&nbsp;'
        alertify.error 'Não é possível inserir um comentário sem conteúdo'
        return

      Loader.on()
      @comment_event.description = '-'
      @comment_event.author = Session.current_user.name
      @comment_event.edition_author = Session.current_user.name
      @comment_event.comment = comment_text
      @comment_events_resource.save @updateSuccess, @unknownError, @comment_event
      @show_comment_modal = false

    updateSuccess: (data) ->
      Loader.off()
      alertify.success 'O comentário foi atualizado com sucesso!'
      EventsBus.$emit 'Comment::CreatedUpdated', data.event

    removeComment: ->
      EventsBus.$emit 'confirm-modal-show', id: 'global_confirm_modal'

    loadVariables: ->
      params = { company_id: Session.current_company.id }
      new VariableResource().index(@loadVariablesSuccess, null, {params})

    loadVariablesSuccess: (resource) ->
      @variables = resource.variables
      @setSummernoteCode()
    
    setSummernoteCode: () ->
      comment =  if (@template && @template.body) then @template.body else ''
      comment = @variablesValues(comment)
      @$comment.summernote('code', comment)
    
    variablesValues: (text) ->
      if(text != '')
        for variable in @variables
          if(@contact[variable.target_method])
            text = text.replace(variable.placeholder, '<span class="'+variable.placeholder_name+'">'+@contact[variable.target_method]+'</span>')
      text

  computed:
    contacts_name: ->
      if @contact
        @contact.full_name

    modal_id: ->
      'confirm-remove-comment-global'+@comment_event.id

    comment_events_resource: ->
      new CommentEventsResource @contact.id

  created: ->
    EventsBus.$on 'reload-contact', @reloadContact
    EventsBus.$on 'Comment::Destroy', @confirmRemoveComment
    EventsBus.$on 'Comment::Edit', @edit
    EventsBus.$on 'Comment::New', @new

  mounted: ->
    @inializeSummernote()
    @loadVariables()

  beforeDestroy:->
    EventsBus.$off 'reload-contact', @reloadContact
    EventsBus.$off 'Comment::Destroy', @confirmRemoveComment
    EventsBus.$off 'Comment::Edit', @edit
    EventsBus.$off 'Comment::New', @new
}

exports.default = helpers.vue_include(view_model, helpers.form, helpers.manual_tasks.list_wrapper, helpers.contacts.styles)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/modals/comment.vue